// extracted by mini-css-extract-plugin
module.exports = {"nav":"styles__nav--3PiG9","logoLink":"styles__logoLink--17pXe","logo":"styles__logo--aJJj2","logoText":"styles__logoText--1C90I"};